import { render } from "./VAmericano.vue?vue&type=template&id=060ace70"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VAmericano.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060ace70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060ace70', __exports__)) {
    api.reload('060ace70', __exports__)
  }
  
  module.hot.accept("./VAmericano.vue?vue&type=template&id=060ace70", () => {
    api.rerender('060ace70', render)
  })

}


export default __exports__